export function indexInRange(length, index, start = 0) {
  return index >= start && index < length;
}

export default { indexInRange };
